<div class="modal-body">
  <div class="header">
    <span>{{ headerMessage }}</span>
    <svg
      (click)="closeModal()"
      width="24"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.48329 5.76877C5.78352 5.4834 6.25824 5.49544 6.54361 5.79567L12 11.5361L17.4564 5.79567C17.7418 5.49544 18.2165 5.4834 18.5167 5.76877C18.8169 6.05414 18.829 6.52886 18.5436 6.82909L13.0348 12.6247L18.5436 18.4203C18.829 18.7206 18.8169 19.1953 18.5167 19.4806C18.2165 19.766 17.7418 19.754 17.4564 19.4537L12 13.7133L6.54361 19.4537C6.25824 19.754 5.78352 19.766 5.48329 19.4806C5.18306 19.1953 5.17102 18.7206 5.45639 18.4203L10.9652 12.6247L5.45639 6.82909C5.17102 6.52886 5.18306 6.05414 5.48329 5.76877Z"
        fill="#679EC6"
      />
    </svg>
  </div>
  @if (!showContactForm) {
    <div class="row plans">
      <div class="col plan">
        <div class="plan-name" i18n="@@office-setting.free">FREE</div>
        <div class="plan-description">
          <div class="desc-wrapper">
            <div class="price">{{ currencySymbol }}0</div>
            <div i18n="@@office-setting.for-one-branch">
              For 1 branch with unlimited users
            </div>
          </div>
        </div>
        <div
          class="button btn-free"
          i18n="@@office-setting.current-plan"
          disabled
        >
          CURRENT PLAN
        </div>
        <hr class="hr-free" />
        <div class="highlights">
          <h2 i18n="@@office-setting.key-features-included">
            Key features included:
          </h2>
          @for (feature of features.free; track feature) {
            <div class="row">
              <div class="col-1">
                <img src="/assets/media/icons/pc-check.svg" alt="." />
              </div>
              <div class="col-11">{{ feature }}</div>
            </div>
          }
        </div>
      </div>
      <div class="col plan">
        <div class="plan-name" i18n="@@office-setting.PRO">PRO</div>
        <div class="plan-description">
          <div class="desc-wrapper">
            <div class="pro-detail row">
              <div class="col-7">First branch</div>
              <div class="col-5">
                <span class="price">{{ currencySymbol }}149</span>
                <span class="per-month">/month</span>
              </div>
            </div>
            <div class="pro-detail row">
              <div class="col-7">Per additional branch</div>
              <div class="col-5">
                <span class="price">{{ currencySymbol }}99</span>
                <span class="per-month">/month</span>
              </div>
            </div>
            <div
              class="pro-moneyback"
              i18n="@@office-setting.annual-billing-money-back"
            >
              *Annual billing with 14-day money back guarantee
            </div>
          </div>
        </div>
        <div
          class="button btn-pro"
          i18n="@@office-setting.upgrade"
          (click)="closeModal('upgrade')"
        >
          UPGRADE
        </div>
        <hr />
        <div class="highlights">
          <h2 i18n="@@office-setting.everything-in-feee-plus">
            Everything in Free, plus:
          </h2>
          @for (feature of features.pro; track feature) {
            <div class="row">
              <div class="col-1">
                <img src="/assets/media/icons/pc-check.svg" alt="." />
              </div>
              <div class="col-11">{{ feature }}</div>
            </div>
          }
          <h2 i18n="@@office-setting.in-product-add-ons-available">
            In-product add-ons available:
          </h2>
          @for (feature of features.inProduct; track feature) {
            <div class="row">
              <div class="col-1">
                <img src="/assets/media/icons/pc-check.svg" alt="." />
              </div>
              <div class="col-11">{{ feature }}</div>
            </div>
          }
        </div>
      </div>
      <div class="col plan">
        <div class="plan-name" i18n="@@office-setting.add-ons">
          ON-REQUEST ADD-ONS
        </div>
        <div class="plan-description">
          <div
            class="tailored"
            i18n="@@office-setting.contact-for-tailored-solution"
          >
            Contact us for the tailored solution!
          </div>
        </div>
        <div
          class="button btn-addon"
          i18n="@@office-setting.contact-us"
          (click)="openContactForm()"
        >
          CONTACT US
        </div>
        <hr />
        <div class="highlights">
          <h2 i18n="@@office-setting.add-ons-available">Add-ons available:</h2>
          @for (feature of features.addons; track feature) {
            <div class="row">
              <div class="col-1">
                <img src="/assets/media/icons/pc-check.svg" alt="." />
              </div>
              <div class="col-11">{{ feature }}</div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (showContactForm) {
    <div id="addonContactForm"></div>
  }
</div>
